import React, { useState } from 'react';
import { MessageCircle, Send, Paperclip, Smile, MoreVertical, Phone, Video, Search, User, Clock, FileText, AlertCircle, CheckCircle } from 'lucide-react';
import NavbarComptable from '../components/NavbarComptable';
import SidebarComptable from '../components/SidebarComptable';

const MessagerieComptable = () => {
    const [selectedConversation, setSelectedConversation] = useState(1);
    const [messageText, setMessageText] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [clients, setClients] = useState([]);

    const conversations = [
        {
            id: 1,
            contact: 'Entreprise ABC SARL',
            avatar: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=150&h=150&fit=crop',
            lastMessage: 'Merci pour le traitement de la déclaration',
            timestamp: '14:32',
            unread: 1,
            status: 'online',
            type: 'client',
            priority: 'normal',
            dossier: 'TVA Q3 2025'
        },
        {
            id: 2,
            contact: 'Restaurant Le Délice',
            avatar: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=150&h=150&fit=crop',
            lastMessage: 'Quand pourrons-nous signer le bilan ?',
            timestamp: '12:20',
            unread: 0,
            status: 'online',
            type: 'client',
            priority: 'urgent',
            dossier: 'Bilan 2024'
        },
        {
            id: 3,
            contact: 'Boutique Mode & Style',
            avatar: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=150&h=150&fit=crop',
            lastMessage: 'Voici les factures de septembre',
            timestamp: '11:45',
            unread: 3,
            status: 'away',
            type: 'client',
            priority: 'normal',
            dossier: 'Comptabilité Sept'
        },
        {
            id: 4,
            contact: 'Garage Auto Pro',
            avatar: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=150&h=150&fit=crop',
            lastMessage: 'Documents CFE reçus',
            timestamp: 'Hier',
            unread: 0,
            status: 'offline',
            type: 'client',
            priority: 'normal',
            dossier: 'CFE 2025'
        },
        {
            id: 5,
            contact: 'SCI Immobilier Plus',
            avatar: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=150&h=150&fit=crop',
            lastMessage: 'Question sur la déclaration des revenus fonciers',
            timestamp: 'Hier',
            unread: 2,
            status: 'online',
            type: 'client',
            priority: 'urgent',
            dossier: 'Déclarations 2024'
        },
        {
            id: 6,
            contact: 'Consulting Digital Solutions',
            avatar: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=150&h=150&fit=crop',
            lastMessage: 'Parfait, merci pour votre réactivité',
            timestamp: 'Lun',
            unread: 0,
            status: 'away',
            type: 'client',
            priority: 'normal',
            dossier: 'Liasse fiscale 2024'
        }
    ];

    const messages = {
        1: [
            {
                id: 1,
                sender: 'Vous',
                content: 'Bonjour ! J\'ai bien reçu vos documents pour la déclaration TVA de juillet.',
                timestamp: '14:25',
                isOwn: true,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Entreprise ABC SARL',
                content: 'Parfait ! Avez-vous pu identifier des points particuliers ?',
                timestamp: '14:27',
                isOwn: false,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Vous',
                content: 'Tout est en ordre. La déclaration a été transmise avec succès. Vous devriez recevoir l\'accusé de réception sous 24h.',
                timestamp: '14:30',
                isOwn: true,
                type: 'text'
            },
            {
                id: 4,
                sender: 'Vous',
                content: 'N\'hésitez pas si vous avez des questions concernant le prochain trimestre.',
                timestamp: '14:30',
                isOwn: true,
                type: 'text'
            },
            {
                id: 5,
                sender: 'Entreprise ABC SARL',
                content: 'Merci pour le traitement de la déclaration',
                timestamp: '14:32',
                isOwn: false,
                type: 'text'
            }
        ],
        2: [
            {
                id: 1,
                sender: 'Vous',
                content: 'Bonjour, votre bilan semestriel est maintenant finalisé.',
                timestamp: '12:10',
                isOwn: true,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Vous',
                content: 'Les documents sont prêts pour signature. Souhaitez-vous un rendez-vous ?',
                timestamp: '12:15',
                isOwn: true,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Restaurant Le Délice',
                content: 'Quand pourrons-nous signer le bilan ?',
                timestamp: '12:20',
                isOwn: false,
                type: 'text'
            }
        ],
        3: [
            {
                id: 1,
                sender: 'Boutique Mode & Style',
                content: 'Bonjour, voici les factures de septembre comme convenu.',
                timestamp: '11:30',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Boutique Mode & Style',
                content: 'J\'ai aussi une question sur la TVA intracommunautaire.',
                timestamp: '11:32',
                isOwn: false,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Boutique Mode & Style',
                content: 'Pourriez-vous m\'expliquer la procédure ?',
                timestamp: '11:33',
                isOwn: false,
                type: 'text'
            }
        ],
        4: [
            {
                id: 1,
                sender: 'Vous',
                content: 'Rappel important : échéance CFE le 15 décembre 2025',
                timestamp: 'Hier 16:45',
                isOwn: true,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Vous',
                content: 'Montant estimé : 850XOF. Pensez à effectuer le paiement avant la date limite.',
                timestamp: 'Hier 16:45',
                isOwn: true,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Garage Auto Pro',
                content: 'Documents CFE reçus',
                timestamp: 'Hier 17:30',
                isOwn: false,
                type: 'text'
            }
        ],
        5: [
            {
                id: 1,
                sender: 'SCI Immobilier Plus',
                content: 'Bonjour, j\'ai une question concernant la déclaration des revenus fonciers.',
                timestamp: 'Hier 14:20',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'SCI Immobilier Plus',
                content: 'Dois-je inclure les charges de copropriété dans les déductions ?',
                timestamp: 'Hier 14:22',
                isOwn: false,
                type: 'text'
            }
        ],
        6: [
            {
                id: 1,
                sender: 'Consulting Digital Solutions',
                content: 'Merci d\'avoir traité notre liasse fiscale si rapidement.',
                timestamp: 'Lun 15:30',
                isOwn: false,
                type: 'text'
            },
            {
                id: 2,
                sender: 'Vous',
                content: 'Avec plaisir ! Tout est conforme et transmis aux services fiscaux.',
                timestamp: 'Lun 15:45',
                isOwn: true,
                type: 'text'
            },
            {
                id: 3,
                sender: 'Consulting Digital Solutions',
                content: 'Parfait, merci pour votre réactivité',
                timestamp: 'Lun 16:00',
                isOwn: false,
                type: 'text'
            }
        ]
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'online':
                return '#10b981';
            case 'away':
                return '#f59e0b';
            case 'offline':
                return '#6b7280';
            default:
                return '#6b7280';
        }
    };

    const getPriorityBadge = (priority) => {
        if (priority === 'urgent') {
            return (
                <span className="priority-badge urgent">
                    <AlertCircle size={12} />
                    Urgent
                </span>
            );
        }
        return null;
    };

    const filteredConversations = conversations.filter(conv =>
        conv.contact.toLowerCase().includes(searchTerm.toLowerCase()) ||
        conv.dossier.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSendMessage = () => {
        if (messageText.trim()) {
            console.log('Message envoyé:', messageText);
            setMessageText('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <>
            <div className="app-container">
                <SidebarComptable
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />
                <div className="main-wrapper">
                    <NavbarComptable 
                        selectedClient={selectedClient}
                        onClientChange={setSelectedClient}
                        clients={clients}
                        onMenuClick={() => setIsSidebarOpen(true)}
                    />

                    <main className="main-content">
                        <div className="page-header">
                            <div className="header-content">
                                <div className="header-text">
                                    <h1 className="page-title">Messagerie Clients</h1>
                                    <p className="page-subtitle">Gérez vos conversations avec vos clients</p>
                                </div>
                                <div className="header-stats">
                                    <div className="stat-card">
                                        <div className="stat-value">
                                            {conversations.filter(c => c.unread > 0).reduce((acc, c) => acc + c.unread, 0)}
                                        </div>
                                        <div className="stat-label">Messages non lus</div>
                                    </div>
                                    <div className="stat-card">
                                        <div className="stat-value">
                                            {conversations.filter(c => c.status === 'online').length}
                                        </div>
                                        <div className="stat-label">Clients en ligne</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="chat-container">
                            <div className="conversations-sidebar">
                                <div className="conversations-header">
                                    <div className="search-box">
                                        <Search size={20} className="search-icon" />
                                        <input
                                            type="text"
                                            placeholder="Rechercher un client ou dossier..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            className="search-input"
                                        />
                                    </div>
                                    <div className="filter-tabs">
                                        <button className="filter-tab active">
                                            Tous ({conversations.length})
                                        </button>
                                        <button className="filter-tab">
                                            Non lus ({conversations.filter(c => c.unread > 0).length})
                                        </button>
                                        <button className="filter-tab">
                                            Urgents ({conversations.filter(c => c.priority === 'urgent').length})
                                        </button>
                                    </div>
                                </div>

                                <div className="conversations-list">
                                    {filteredConversations.map((conversation) => (
                                        <div
                                            key={conversation.id}
                                            className={`conversation-item ${selectedConversation === conversation.id ? 'active' : ''}`}
                                            onClick={() => setSelectedConversation(conversation.id)}
                                        >
                                            <div className="conversation-avatar">
                                                <img src={conversation.avatar} alt={conversation.contact} />
                                                <div
                                                    className="status-indicator"
                                                    style={{ backgroundColor: getStatusColor(conversation.status) }}
                                                ></div>
                                            </div>
                                            <div className="conversation-info">
                                                <div className="conversation-header">
                                                    <h4 className="conversation-name">{conversation.contact}</h4>
                                                    <span className="conversation-time">{conversation.timestamp}</span>
                                                </div>
                                                <div className="conversation-dossier">
                                                    <FileText size={12} />
                                                    <span>{conversation.dossier}</span>
                                                </div>
                                                <div className="conversation-preview">
                                                    <p className="last-message">{conversation.lastMessage}</p>
                                                    {conversation.unread > 0 && (
                                                        <span className="unread-badge">{conversation.unread}</span>
                                                    )}
                                                </div>
                                                {getPriorityBadge(conversation.priority)}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="chat-main">
                                {selectedConversation ? (
                                    <>
                                        <div className="chat-header">
                                            <div className="chat-contact-info">
                                                <img
                                                    src={conversations.find(c => c.id === selectedConversation)?.avatar}
                                                    alt="Contact"
                                                    className="chat-avatar"
                                                />
                                                <div className="chat-contact-details">
                                                    <h3 className="chat-contact-name">
                                                        {conversations.find(c => c.id === selectedConversation)?.contact}
                                                    </h3>
                                                    <div className="chat-contact-meta">
                                                        <FileText size={14} />
                                                        <span>{conversations.find(c => c.id === selectedConversation)?.dossier}</span>
                                                        <span className="separator">•</span>
                                                        <span className={`status-text ${conversations.find(c => c.id === selectedConversation)?.status}`}>
                                                            {conversations.find(c => c.id === selectedConversation)?.status === 'online' ? 'En ligne' :
                                                                conversations.find(c => c.id === selectedConversation)?.status === 'away' ? 'Absent' : 'Hors ligne'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="chat-actions">
                                                <button className="chat-action-btn">
                                                    <Phone size={20} />
                                                </button>
                                                <button className="chat-action-btn">
                                                    <Video size={20} />
                                                </button>
                                                <button className="chat-action-btn">
                                                    <FileText size={20} />
                                                </button>
                                                <button className="chat-action-btn">
                                                    <MoreVertical size={20} />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="messages-area">
                                            <div className="messages-list">
                                                {(messages[selectedConversation] || []).map((message) => (
                                                    <div
                                                        key={message.id}
                                                        className={`message ${message.isOwn ? 'own' : 'other'}`}
                                                    >
                                                        {!message.isOwn && (
                                                            <div className="message-avatar">
                                                                <User size={16} />
                                                            </div>
                                                        )}
                                                        <div className="message-content">
                                                            <div className="message-bubble">
                                                                <p className="message-text">{message.content}</p>
                                                            </div>
                                                            <div className="message-meta">
                                                                <span className="message-time">
                                                                    <Clock size={12} />
                                                                    {message.timestamp}
                                                                </span>
                                                                {message.isOwn && (
                                                                    <CheckCircle size={12} className="read-indicator" />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="message-input-area">
                                            <div className="quick-responses">
                                                <button className="quick-response-btn">
                                                    Documents reçus ✓
                                                </button>
                                                <button className="quick-response-btn">
                                                    Je reviens vers vous
                                                </button>
                                                <button className="quick-response-btn">
                                                    Rendez-vous confirmé
                                                </button>
                                            </div>
                                            <div className="message-input-container">
                                                <button className="attachment-btn">
                                                    <Paperclip size={20} />
                                                </button>
                                                <div className="input-wrapper">
                                                    <textarea
                                                        value={messageText}
                                                        onChange={(e) => setMessageText(e.target.value)}
                                                        onKeyPress={handleKeyPress}
                                                        placeholder="Répondre au client..."
                                                        className="message-input"
                                                        rows="1"
                                                    />
                                                </div>
                                                <button className="emoji-btn">
                                                    <Smile size={20} />
                                                </button>
                                                <button
                                                    onClick={handleSendMessage}
                                                    className="send-btn"
                                                    disabled={!messageText.trim()}
                                                >
                                                    <Send size={20} />
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="no-conversation">
                                        <MessageCircle size={64} className="no-conversation-icon" />
                                        <h3>Sélectionnez un client</h3>
                                        <p>Choisissez une conversation dans la liste pour commencer à échanger</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }

                .app-container {
                    display: flex;
                    height: 100vh;
                    background: linear-gradient(135deg, #f8fafb 0%, #f1f5f9 100%);
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                }

                .main-wrapper {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin-left: 320px;
                }

                .main-content {
                    flex: 1;
                    padding: 32px;
                    overflow: auto;
                    
                }
                /* Page Header */
                .page-header {
                    margin-bottom: 24px;
                }

                .header-content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 24px;
                }

                .page-title {
                    font-size: 32px;
                    font-weight: 700;
                    margin: 0 0 6px 0;
                    background: linear-gradient(135deg, #dc3545, #008A44);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    line-height: 1.2;
                    letter-spacing: -0.5px;
                }

                .page-subtitle {
                    color: #64748b;
                    margin: 0;
                    font-size: 16px;
                    font-weight: 500;
                }

                .header-stats {
                    display: flex;
                    gap: 16px;
                }

                .stat-card {
                    background: #ffffff;
                    padding: 16px 24px;
                    border-radius: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
                    text-align: center;
                    min-width: 120px;
                }

                .stat-value {
                    font-size: 28px;
                    font-weight: 700;
                    background: linear-gradient(135deg, #dc3545, #008A44);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    margin-bottom: 4px;
                }

                .stat-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 500;
                }

                /* Chat Container */
                .chat-container {
                    flex: 1;
                    display: flex;
                    background: #ffffff;
                    border-radius: 16px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                    border: 1px solid rgba(0, 0, 0, 0.05);
                    overflow: hidden;
                    min-height: 0;
                }

                /* Conversations Sidebar */
                .conversations-sidebar {
                    width: 400px;
                    border-right: 1px solid #f1f5f9;
                    display: flex;
                    flex-direction: column;
                    background: #fafbfc;
                }

                .conversations-header {
                    padding: 20px;
                    border-bottom: 1px solid #f1f5f9;
                    background: #ffffff;
                }

                .search-box {
                    position: relative;
                    margin-bottom: 16px;
                }

                .search-icon {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #9ca3af;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 48px;
                    border: 1px solid #d1d5db;
                    border-radius: 12px;
                    background: #ffffff;
                    font-size: 14px;
                    font-family: inherit;
                    transition: all 0.2s ease;
                }

                .search-input:focus {
                    outline: none;
                    border-color: #10b981;
                    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
                }

                .filter-tabs {
                    display: flex;
                    gap: 8px;
                }

                .filter-tab {
                    flex: 1;
                    padding: 8px 12px;
                    border: 1px solid #e2e8f0;
                    background: #ffffff;
                    border-radius: 8px;
                    font-size: 12px;
                    font-weight: 500;
                    color: #64748b;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .filter-tab.active {
                    background: linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(0, 138, 68, 0.1) 100%);
                    border-color: #10b981;
                    color: #10b981;
                }

                .filter-tab:hover:not(.active) {
                    background: #f8fafc;
                }

                .conversations-list {
                    flex: 1;
                    overflow-y: auto;
                    scrollbar-width: thin;
                    scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
                }

                .conversations-list::-webkit-scrollbar {
                    width: 4px;
                }

                .conversations-list::-webkit-scrollbar-thumb {
                    background: rgba(0, 138, 68, 0.2);
                    border-radius: 10px;
                }

                .conversation-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    padding: 16px 20px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
                    position: relative;
                }

                .conversation-item:hover {
                    background: #ffffff;
                }

                .conversation-item.active {
                    background: linear-gradient(135deg, rgba(220, 53, 69, 0.08) 0%, rgba(0, 138, 68, 0.08) 100%);
                    border-right: 3px solid #10b981;
                }

                .conversation-avatar {
                    position: relative;
                    flex-shrink: 0;
                }

                .conversation-avatar img {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid #ffffff;
                }

                .status-indicator {
                    position: absolute;
                    bottom: 2px;
                    right: 2px;
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    border: 2px solid #ffffff;
                }

                .conversation-info {
                    flex: 1;
                    min-width: 0;
                }

                .conversation-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 4px;
                }

                .conversation-name {
                    font-size: 15px;
                    font-weight: 600;
                    color: #1e293b;
                    margin: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .conversation-time {
                    font-size: 12px;
                    color: #94a3b8;
                    flex-shrink: 0;
                }

                .conversation-dossier {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 12px;
                    color: #64748b;
                    margin-bottom: 6px;
                }

                .conversation-preview {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 8px;
                }

                .last-message {
                    font-size: 13px;
                    color: #475569;
                    margin: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    flex: 1;
                }

                .unread-badge {
                    background: #10b981;
                    color: #ffffff;
                    font-size: 10px;
                    font-weight: 600;
                    padding: 2px 6px;
                    border-radius: 12px;
                    flex-shrink: 0;
                }

                .priority-badge {
                    position: absolute;
                    top: 12px;
                    right: 20px;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 10px;
                    font-weight: 600;
                    padding: 2px 6px;
                    border-radius: 12px;
                    color: #b91c1c;
                }

                .priority-badge.urgent {
                    background: rgba(185, 28, 28, 0.1);
                }

                /* Chat Main Area */
                .chat-main {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                }

                .chat-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 20px;
                    border-bottom: 1px solid #f1f5f9;
                    background: #ffffff;
                }

                .chat-contact-info {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .chat-avatar {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid #ffffff;
                }

                .chat-contact-details {
                    display: flex;
                    flex-direction: column;
                }

                .chat-contact-name {
                    font-size: 18px;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0 0 4px 0;
                }

                .chat-contact-meta {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;
                    color: #64748b;
                }

                .chat-contact-meta .separator {
                    margin: 0 4px;
                    color: #cbd5e1;
                }

                .status-text {
                    text-transform: capitalize;
                }

                .status-text.online {
                    color: #10b981;
                }

                .status-text.away {
                    color: #f59e0b;
                }

                .status-text.offline {
                    color: #6b7280;
                }

                .chat-actions {
                    display: flex;
                    gap: 12px;
                }

                .chat-action-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #64748b;
                    padding: 8px;
                    border-radius: 8px;
                    transition: background 0.2s ease;
                }

                .chat-action-btn:hover {
                    background: #f1f5f9;
                }

                .messages-area {
                    flex: 1;
                    padding: 20px;
                    overflow-y: auto;
                    scrollbar-width: thin;
                    scrollbar-color: rgba(0, 138, 68, 0.3) transparent;
                }

                .messages-area::-webkit-scrollbar {
                    width: 4px;
                }

                .messages-area::-webkit-scrollbar-thumb {
                    background: rgba(0, 138, 68, 0.2);
                    border-radius: 10px;
                }

                .messages-list {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .message {
                    display: flex;
                    align-items: flex-end;
                    gap: 12px;
                }

                .message.own {
                    flex-direction: row-reverse;
                }

                .message-avatar {
                    flex-shrink: 0;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    background: #e5e7eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #6b7280;
                }

                .message-content {
                    max-width: 70%;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                .message.own .message-content {
                    align-items: flex-end;
                }

                .message-bubble {
                    background: #f1f5f9;
                    padding: 12px 16px;
                    border-radius: 16px;
                    position: relative;
                }

                .message.own .message-bubble {
                    background: #10b981;
                    color: #ffffff;
                }

                .message-text {
                    margin: 0;
                    font-size: 14px;
                    line-height: 1.4;
                }

                .message-meta {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 10px;
                    color: #94a3b8;
                }

                .message-time {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                }

                .read-indicator {
                    color: #10b981;
                }

                .message-input-area {
                    padding: 16px 20px;
                    border-top: 1px solid #f1f5f9;
                    background: #fafbfc;
                }

                .quick-responses {
                    display: flex;
                    gap: 8px;
                    margin-bottom: 12px;
                    flex-wrap: wrap;
                }

                .quick-response-btn {
                    background: #ffffff;
                    border: 1px solid #d1d5db;
                    border-radius: 20px;
                    padding: 6px 12px;
                    font-size: 12px;
                    color: #475569;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .quick-response-btn:hover {
                    background: #f1f5f9;
                    border-color: #10b981;
                }

                .message-input-container {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }

                .input-wrapper {
                    flex: 1;
                }

                .attachment-btn,
                .emoji-btn,
                .send-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #64748b;
                    padding: 8px;
                    border-radius: 8px;
                    transition: all 0.2s ease;
                    flex-shrink: 0;
                }

                .attachment-btn:hover,
                .emoji-btn:hover {
                    background: #f1f5f9;
                }

                .send-btn:hover:not(:disabled) {
                    background: #10b981;
                    color: #ffffff;
                }

                .message-input {
                    width: 100%;
                    padding: 12px 16px;
                    border: 1px solid #d1d5db;
                    border-radius: 12px;
                    background: #ffffff;
                    font-size: 14px;
                    font-family: inherit;
                    resize: none;
                    transition: all 0.2s ease;
                    min-height: 44px;
                    max-height: 120px;
                }

                .message-input:focus {
                    outline: none;
                    border-color: #10b981;
                    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
                }

                .send-btn:disabled {
                    color: #cbd5e1;
                    cursor: not-allowed;
                }

                .no-conversation {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: #94a3b8;
                    text-align: center;
                    padding: 40px;
                }

                .no-conversation-icon {
                    color: #e5e7eb;
                    margin-bottom: 16px;
                }

                .no-conversation h3 {
                    font-size: 20px;
                    margin: 0 0 8px 0;
                    color: #64748b;
                }

                .no-conversation p {
                    font-size: 14px;
                    margin: 0;
                    color: #94a3b8;
                }

                /* Responsive Design */
                @media (max-width: 1024px) {
                    .conversations-sidebar {
                        width: 320px;
                    }

                    .header-stats {
                        flex-direction: column;
                    }
                }

                @media (max-width: 768px) {
                    .main-content {
                        padding: 16px;
                    }

                    .page-title {
                        font-size: 24px;
                    }

                    .conversations-sidebar {
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        z-index: 100;
                        width: 100%;
                        max-width: 320px;
                    }

                    .header-content {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .message-content {
                        max-width: 85%;
                    }
                }
            `}
            </style>
        </>
    );
};
export default MessagerieComptable;